export const NAVIGATION_CARDS = [
  {
    title: "Welcome",
    image: "/projects/welcome-screenshot.png",
    desc: "",
    link: "/",
    hide: true,
  },
  {
    title: "lLofi donuts",
    image: "/projects/lofi-donuts-screenshot.png",
    desc: "",
    link: "donuts",
  },
  {
    title: "Audio Galaxy",
    image: "/projects/audio-galaxy-screenshot.png",
    desc: "",
    link: "galaxy",
  },
  {
    title: "Moon fox",
    image: "/projects/moon-fox-screenshot.png",
    desc: "",
    link: "target-morph",
  },

  {
    title: "Anime objects",
    image: "/projects/anime-objects.png",
    desc: "",
    link: "animatedObjects",
    hide: true,
  },
  {
    title: "Lab alpha",
    image: "",
    desc: "",
    link: "lab-alpha",
    hide: true,
  },
];
